/*
IMPORTANT!: these event name keys and values are constant
if needs to be changed then get a confirmation from Acquisition backend team as they have used the same for mapping, hence changing on FE will impact the service
if new key-value needs to be added, even then get a confirmation from Acquisition backend team
ticket reference: https://asiatvusa.atlassian.net/browse/CX-13354
*/
export const META_EVENTS = {
  Addtocart: 'Addtocart',
  BuyPremium: 'BuyPremium',
  EmailVerified: 'EmailVerified',
  OTPVerified: 'OTPVerified',
  Completeregistration: 'Completeregistration',
  MetaSubscriptionPage: 'metaSubscriptionpage',
  Initiatecheckout: 'Initiatecheckout',
  Purchase: 'Purchase',
  PageView: 'PageView'
};
